import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { VerticalTimelineElement } from 'react-vertical-timeline-component';

import { cssVar } from '@feathr/hooks';

import { flavorToColorMap } from '../FlavorChip';

import 'react-vertical-timeline-component/style.min.css';
import * as styles from './BreadcrumbsTimeline.css';

function BreadcrumbsTimelineElementLoader(): JSX.Element {
  const flavorsOverride = {
    ...flavorToColorMap,
    default: 'slate',
  };
  return (
    <VerticalTimelineElement
      className={styles.item}
      icon={<FontAwesomeIcon icon={faSpinnerThird} spin={true} />}
      iconClassName={styles.icon}
      iconStyle={{
        backgroundColor: cssVar(`--color-${flavorsOverride.default}-50`),
        color: cssVar(`--color-${flavorsOverride.default}-700`),
      }}
    />
  );
}

export default BreadcrumbsTimelineElementLoader;
